import React, { useContext } from 'react';
import StateContext from 'common/contexts/state-context';
import GoodaysWidget from '../../../ui/GoodaysWidget';
import ReviewGrid from '../../../ui/ReviewGrid';
import Eyebrow from '../../../ui/Eyebrow';
import { NETWORK_RATING, NETWORK_REVIEWS } from '../../../staticContent';
import { WpWidget } from '../../../widgets/WpChrome';
import { USE_WP_WIDGETS, USE_WP_CHROME } from '../../../GlobalValues';

/**
 * `.note` — note moyenne réseau (§9, ligne 2.e) via l'API Goodays, agrégat
 * uniquement (jamais le widget embarqué, pour préserver les Web Vitals).
 * La colonne des avis (droite) est un `<wp-widget>` une fois le plugin
 * installé (§9, ligne 2.e).
 *
 * `.note-text` est un bloc éditorial autonome dans la maquette, distinct de
 * `.head-row`/`.section-title` (qui sert ailleurs) — on ne réutilise donc pas
 * `SectionHead` ici, pour ne pas hériter d'un balisage qui ne correspond à
 * aucune règle CSS de ce bloc.
 */
const NetworkReviews = () => {
  const [state] = useContext(StateContext);
  // Agrégat pondéré par le nombre d'avis, calculé côté serveur sur les seuls
  // salons de l'enseigne (la clé d'API Goodays en couvre plusieurs).
  const network = state.goodays?.network;

  const hasRating = Boolean(network?.rating);

  return (
  <section
    // Même correctif que `CollectionSlider` : quand le chrome WordPress est
    // actif, le widget `<wp-footer>` qui suit porte déjà sa propre bordure du
    // dessus — sans ça, les deux bordures se cumulent visuellement.
    className={['note', USE_WP_CHROME ? 'note-no-bottom-border' : null].filter(Boolean).join(' ')}
    id="avis-clients"
  >
    {/* Même précaution que sur l'onglet Avis de la fiche salon : `.note-score` est
        une carte blanche bordée et ombrée, un `GoodaysWidget` qui renvoie `null`
        (agrégat indisponible) y laisserait un cadre vide. */}
    <div className={hasRating ? 'container' : 'container no-score'}>
      {hasRating && (
        <div className="note-score">
          <GoodaysWidget
            variant="hero"
            label={NETWORK_RATING.label}
            value={network.rating}
            reviewCount={network.reviewCount}
          />
        </div>
      )}
      <div className="note-text">
        <Eyebrow variant="white">Avis clients</Eyebrow>
        <h2>
          {NETWORK_REVIEWS.title.line1} <span className="hl">{NETWORK_REVIEWS.title.highlight}</span>
        </h2>
        <p>{NETWORK_REVIEWS.subtitle}</p>
        {USE_WP_WIDGETS ? (
          <WpWidget slug="avis" fallback={<ReviewGrid reviews={NETWORK_REVIEWS.reviews} />} />
        ) : (
          <ReviewGrid reviews={NETWORK_REVIEWS.reviews} />
        )}
      </div>
    </div>
  </section>
  );
};

export default NetworkReviews;
